import { useEffect } from 'react';

import { sharedCoverLetterClientDocumentVariable } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

export const useLastCoverLetter = (): void => {
  const handleLocalDocument = (): void => {
    const localCoverLetterString =
      global?.window?.localStorage?.getItem('vita-cover-letter');
    const localCvString =
      global?.window?.localStorage?.getItem('vita-document');

    if (localCoverLetterString && localCvString) {
      const localCoverLetter = JSON.parse(localCoverLetterString);
      const { cv: localCv } = JSON.parse(localCvString);

      const inheritValuesFromCv = (): void => {
        Object.entries(localCoverLetter.personalInformation).map(
          ([key, value]) => {
            localCoverLetter.personalInformation[key] =
              value || localCv.personalInformation[key];
          }
        );

        if (localCoverLetter.professionalExperience?.length === 0) {
          localCoverLetter.professionalExperience =
            localCv.professionalExperience;
        }

        if (localCoverLetter.skills?.length === 0) {
          localCoverLetter.skills = localCv.skills;
        }

        if (localCoverLetter.educationExperience?.length === 0) {
          localCoverLetter.educationExperience = localCv.educationExperience;
        }
      };

      inheritValuesFromCv();

      sharedCoverLetterClientDocumentVariable(localCoverLetter);
    }
  };

  useEffect(() => {
    handleLocalDocument();
  }, []);
};
